import { useContext, useMemo } from "react";
import ConditionalLink from "./conditional-link";
import Icon from "./icon";
import classNames from "classnames";
import UserContext from "../context/user";

const AppLinkCardHomepage = ({ item, tealiumId }) => {
  const { openAuthLink } = useContext(UserContext);

  const name = item.title || item.name;
  const href = useMemo(() => {
    if (item?.linkURL) {
      if (item?.subjectTaxonomy?.[0]?.externalReference) {
        const params = new URLSearchParams();
        params.append("target", item.linkURL);
        params.append("externalReference", item.subjectTaxonomy[0].externalReference);
        return `/bff/authorization/samlRequest?${params.toString()}`;
      } else {
        return item.linkURL;
      }
    } else {
      return "#";
    }
  }, [item]);

  return (
    <ConditionalLink
      to={href}
      target="_blank"
      className={classNames("favorites-homepage", {
        "loading-highlighted": !name,
      })}
      onClick={openAuthLink}
      data-id={item.masterID}
      data-element-id={tealiumId}
      aria-label={name}
    >
      <div className="favorites-homepage__text">{name}</div>
      <Icon name={"arrow"} className="favorites-homepage__icon" />
    </ConditionalLink>
  );
};

export default AppLinkCardHomepage;
